import React, { Dispatch, ReactNode, SetStateAction, useEffect } from "react";
import Close from "../SVGs/Close";
import * as Dialog from "@radix-ui/react-dialog";

interface ModalType {
  children?: ReactNode;
  isOpen: boolean;
  toggle: Dispatch<SetStateAction<boolean>>;
  customContentClass?: string;
  setIsPlaying: Dispatch<SetStateAction<boolean>>;
}

const Modal: React.FC<ModalType> = ({
  isOpen,
  toggle,
  children,
  customContentClass,
  setIsPlaying,
}) => {
  const handleModalOpen = (state: boolean) => {
    toggle(state);
    setIsPlaying(state);
  };

  useEffect(() => {
    if (isOpen) {
      setIsPlaying(true);
    }
  }, [isOpen]);

  return (
    <Dialog.Root open={isOpen} onOpenChange={handleModalOpen}>
      <Dialog.Portal>
        <Dialog.Overlay className="dialog--overlay">
          <Dialog.Close asChild>
            <button
              type="button"
              onClick={() => handleModalOpen(false)}
              className="dialog--close__button"
            >
              <Close />
            </button>
          </Dialog.Close>
        </Dialog.Overlay>
        <Dialog.Content className={`dialog--content ${customContentClass}`}>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
